var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoPurple(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3309 10.8315L17.6826 13.7327C17.7453 13.7744 17.8182 13.7984 17.8935 13.802C17.9687 13.8056 18.0436 13.7887 18.11 13.7531C18.1764 13.7176 18.232 13.6646 18.2707 13.6C18.3094 13.5354 18.3299 13.4614 18.3299 13.3861V6.55734C18.33 6.48404 18.3106 6.41203 18.2739 6.34858C18.2372 6.28514 18.1844 6.2325 18.1209 6.19599C18.0573 6.15947 17.9852 6.14038 17.9119 6.14063C17.8386 6.14088 17.7667 6.16046 17.7034 6.1974L13.3309 8.7486",
    stroke: "#9810FA",
    strokeWidth: 1.66636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6645 5H3.33271C2.41241 5 1.66635 5.74605 1.66635 6.66636V13.3318C1.66635 14.2521 2.41241 14.9981 3.33271 14.9981H11.6645C12.5848 14.9981 13.3309 14.2521 13.3309 13.3318V6.66636C13.3309 5.74605 12.5848 5 11.6645 5Z",
    stroke: "#9810FA",
    strokeWidth: 1.66636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPurple);
export default __webpack_public_path__ + "static/media/video_purple.9bf3caca65b2bdff36169d7a9e046e2b.svg";
export { ForwardRef as ReactComponent };